export enum CreditCodeType {
  Fund = 'fund',
  Label = 'label',
}

export interface ExcludedService {
  provider: string;
  serviceCode: string;
}

/**
 * Deferred campaigns hand out the credit later, once the account spent `spendThreshold` on eligible
 * labels within `earnWindowDays` of signing up.
 */
export interface DeferredCreditRule {
  spendThreshold: number;
  earnWindowDays: number;
  requireVerifiedCard: boolean;
  excludeInternational: boolean;
  excludedServices: ExcludedService[];
}

export interface DeliveryService {
  code: string;
  label: string;
  provider: string;
  international: boolean;
}
